import { MonthKey } from "./types";

export function formatMoney(cents: number, currency: string, compact = false): string {
    return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency,
        notation: compact ? "compact" : "standard",
        maximumFractionDigits: compact ? 1 : 2,
    }).format(cents / 100);
}

// "12.50" or "12,50" -> 1250; returns null for anything that isn't a positive amount
export function parseAmount(input: string): number | null {
    const value = Number(input.trim().replace(",", "."));
    if (!isFinite(value) || value <= 0) {
        return null;
    }
    return Math.round(value * 100);
}

export function toDateKey(date: Date): string {
    const pad = (n: number) => String(n).padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

export function monthOf(dateKey: string): MonthKey {
    return dateKey.slice(0, 7);
}

export function shiftMonth(month: MonthKey, delta: number): MonthKey {
    const [year, m] = month.split("-").map(Number);
    const date = new Date(year, m - 1 + delta, 1);
    return toDateKey(date).slice(0, 7);
}

export function formatMonth(month: MonthKey, style: "long" | "short" = "long"): string {
    const [year, m] = month.split("-").map(Number);
    return new Date(year, m - 1, 1).toLocaleDateString("en-US", {
        month: style,
        year: style === "long" ? "numeric" : undefined,
    });
}

export function formatDay(dateKey: string): string {
    const [year, m, d] = dateKey.split("-").map(Number);
    return new Date(year, m - 1, d).toLocaleDateString("en-US", { day: "numeric", month: "short" });
}
